import { computed, useState } from "#imports";
import { getOidcClient } from "../utils/client.js";
export function useAuth() {
  const authState = useState("auth");
  const idToken = computed(() => authState.value.user?.id_token);
  const isLoggedIn = computed(() => authState.value.loggedIn);
  const userProfile = computed(() => authState.value.user?.profile);
  const headers = computed(() => ({
    Authorization: `${authState.value.user?.token_type} ${authState.value.user?.id_token}`
  }));
  return {
    state: authState,
    idToken,
    isLoggedIn,
    userProfile,
    headers
  };
}
export function useOidcClient() {
  return getOidcClient;
}
